import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NecUrl } from '../../model/url/url';
import { Observable } from 'rxjs';
import { OssToken } from '../../model/oss/oss-token';
import { Trans } from '../../model/oss/trans';


/**
 * ç¨æ·ç¸å³åå°æ¥å£
 */
@Injectable()
export class NecOssInterface {
  constructor(private http: HttpClient) {
  }

  /**
   * æ¥è¯¢åªä½èµæºè½¬ç ç¶æ
   * @param resKeyList ä¸ä¼ æåkeyåè¡¨
   */
  getTranscodeStatus(resKeyList): Observable<Trans[]> {
    return this.http.post<Trans[]>(NecUrl.SERVER_URL + '/mts/transDetailQuery', resKeyList);
  }

  /**
   * è·ååªä½OSSToken
   * @param resId æå±èµæºid
   */
  getMediaOperationOssToken(resId): Observable<OssToken> {
    let options = { params: null };
    if (resId && resId.indexOf('user') < 0) {
      options.params = new HttpParams().set('resId', resId.toString());
    }

    return this.http.get<OssToken>(NecUrl.SERVER_URL + '/server/media/cosToken', options);
  }
}
